import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { TextInput, Services, Modal, PhoneInput, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { createBrokerage } from '../actions/master.js';

class BrokerageForm extends PureComponent {
    state = {
        name: '',
        addressLineOne: '',
        addressLineTwo: '',
        city: '',
        province: 'Alberta',
        postalCode: '',
        phone: '',
        nameError: false,
        addressError: false,
        phoneError: false,
        showConfirmForm: false
    };

    _validateForm = async () => {
        const nameError = await Services.validateInput('checkEmpty', this.state.name);
        const addressLineOneError = await Services.validateInput('addressLineOne', this.state.addressLineOne);
        const cityError = await Services.validateInput('city', this.state.city);
        const provinceError = await Services.validateInput('province', this.state.province);
        const postalCodeError = await Services.validateInput('postalCode', this.state.postalCode);

        const phoneError = await Services.validateInput('phone', this.state.phone);

        this.setState({
            nameError,
            addressLineOneError,
            cityError,
            provinceError,
            postalCodeError,
            phoneError
        });

        if (
            nameError ||
            addressLineOneError ||
            cityError ||
            provinceError ||
            postalCodeError ||
            phoneError
        ) {
            return false;
        }

        return true;
    };

    _createBrokerage = async () => {
        const isFormValid = await this._validateForm();

        if (!isFormValid) {
            return false;
        }

        const {
            name,
            phone,
            addressLineOne,
            addressLineTwo,
            city,
            postalCode,
            province
        } = this.state;

        const data = {
            name,
            phone,
            addressLineOne,
            addressLineTwo: addressLineTwo || null,
            city,
            province,
            postalCode
        };

        this._clear();
        await this.props.dispatch(createBrokerage(data));
        return null;
    };

    _hideForm = () => {
        this.setState({
            showConfirmForm: false
        });
    };

    _clear = () => {
        this.setState({
            name: '',
            nameError: false,
            address: '',
            addressError: false,
            phone: '',
            phoneError: false
        });

        this.props.close();
    };

    _onBlur = async (type) => {
        this.setState({
            [`${ type }Error`]: await Services.validateInput('checkEmpty', this.state[type])
        });
    };

    _handleInputChange = (type, event, isValue = false) => {
        this.setState({
            [type]: isValue ? event : event.target.value
        });
    };

    /**
     * 
     * @param {*} input 
     */
    _formatPostalCode = async (input) => {
        const formattedPostalCode = input
            .toUpperCase()
            .trim()
            .replace(/\s+/g, '') // Remove all spaces
            .replace(/([A-Z0-9]{3})([A-Z0-9]{3})/, '$1 $2'); // Add a space after the first 3 characters

        await this._handleInputChange('postalCode', formattedPostalCode, true);
        this._onBlur('postalCode');
    };

    render() {
        const styles = {
            row: {
                display: 'flex',
                flexDirection: 'row'
            },
            divider: {
                width: 40
            }
        };

        return (
            <Modal
                open={true}
                onClose={this.props.close}
                title="Add Brokerage"
                primaryButton={{
                    label: "Create Brokerage",
                    onClick: this._createBrokerage
                }}
                loader={this.props.loader}
            >
                <TextInput
                    label="Name"
                    value={this.state.name}
                    onBlur={() => this._onBlur('name')}
                    onChange={(value) => this._handleInputChange('name', value)}
                    error={Boolean(this.state.nameError)}
                    helperText={this.state.nameError}
                    fullWidth
                    required
                    autoFocus
                />
                <TextInput
                    label="Address Line One"
                    autocomplete="shipping street-address"
                    value={this.state.addressLineOne}
                    onBlur={() => this._onBlur('addressLineOne')}
                    onChange={(value) => this._handleInputChange('addressLineOne', value)}
                    error={Boolean(this.state.addressLineOneError)}
                    helperText={this.state.addressLineOneError}
                    fullWidth
                />

                <div style={ styles.row }>
                    <TextInput
                        label={i18n.t(tokens.labels.addressLineTwo)}
                        value={this.state.addressLineTwo}
                        onBlur={() => this._onBlur('addressLineTwo')}
                        onChange={(value) => this._handleInputChange('addressLineTwo', value)}
                        fullWidth
                        helperText={i18n.t(tokens.labels.addressLineTwoExample)}
                    />
                    <div style={ styles.divider} />
                    <TextInput
                        label="City/Town"
                        value={this.state.city}
                        onBlur={() => this._onBlur('city')}
                        onChange={(value) => this._handleInputChange('city', value)}
                        error={Boolean(this.state.cityError)}
                        helperText={this.state.cityError}
                        fullWidth
                    />
                </div>

                <div style={ styles.row}>
                    <TextInput
                        label="Province"
                        value={this.state.province || 'Alberta'}
                        onBlur={() => this._onBlur('province')}
                        onChange={(value) => this._handleInputChange('province', value)}
                        select
                        selectOptions={Services.selectFieldOptions.provinceOptions()}
                        fullWidth
                    />

                    <div style={ styles.divider} />

                    <TextInput
                        label="Postal Code"
                        value={this.state.postalCode}
                        onBlur={(e) => this._formatPostalCode(e.target.value)}
                        onChange={(e) => {
                            // Allow typing only 6 alphanumeric characters and trim any excess
                            const postalCodeValue = e.target.value
                                .toUpperCase()
                                .slice(0, 7);
                            this._handleInputChange('postalCode', postalCodeValue, true);
                        }}
                        error={Boolean(this.state.postalCodeError)}
                        helperText={this.state.postalCodeError}
                        fullWidth
                    />
                </div>

                <PhoneInput
                    label="Phone Number"
                    onBlur={() => this._onBlur('phone')}
                    onChange={(value) => this._handleInputChange('phone', value)}
                    error={Boolean(this.state.phoneError)}
                    helperText={this.state.phoneError}
                    fullWidth
                />
            </Modal>
        );
    }
}

export default connect()(BrokerageForm);